import { Injectable } from '@angular/core';
import{Subject}from 'rxjs'
import { User } from '../modules/principal/models/usermodel';


@Injectable({
  providedIn: 'root'
})
export class LogincacheService {
  public usserLogged:User;
  public codigo:string;

  constructor() { }

  private enviarcodigoSubject=new Subject<string>();
      enviarcodigoObservable=this.enviarcodigoSubject.asObservable();

      enviarCodigo(codigo:string){
        this.codigo=codigo;
        this.enviarcodigoSubject.next(codigo);
      }
    
      setUserLoggedIn(user:User) {
        this.usserLogged = user;
        localStorage.setItem('info', JSON.stringify(user));
      } 
    
      getUserLoggedIn() {
        return JSON.parse(localStorage.getItem('info'));
      }

}

